import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionCommandHandlerService {


  // Method used to save the subscription date in the local storage
  public save(){
    localStorage.setItem('subscriptionDate', new Date().toISOString());
  }

  // Method used to check if the subscription is pending
  public hasPending(): boolean {
    const subscriptionDate = localStorage.getItem('subscriptionDate');
    if (!subscriptionDate) {
      return false;
    }

    // Check if the subscription is less than 15 minutes old
    const lastSubscriptionDate = new Date(subscriptionDate);
    const now = new Date();
    const diff = Math.ceil((now.getTime() - lastSubscriptionDate.getTime()) / (1000 * 60));
    return diff <= 15;
  }
}
